
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/gold-loans/glfh-payments-related",
      function () {
        return require("private-next-pages/help/gold-loans/glfh-payments-related.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/gold-loans/glfh-payments-related"])
      });
    }
  